export const checkFormIsDirty = (dirtyFields: Record<string, boolean>) => {
  const fields = Object.keys(dirtyFields).filter(
    item => item !== 'google_places_id' && item !== 'provider_id',
  );

  return fields.length > 0;
};
